import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Focusable } from '../../services/autofocus/focusable';
import { RichTextEditorServiceService } from '../../services/rich-text-editor/rich-text-editor-service.service';
import { TokenRenewalService } from '../../services/token-renewal/token-renewal.service';

@Component({
  selector: 'bom-rich-text-editor',
  templateUrl: './rich-text-editor.component.html',
  styleUrls: ['./rich-text-editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: RichTextEditorComponent,
    },
  ],
})
export class RichTextEditorComponent implements OnInit, ControlValueAccessor, Focusable {
  @Input()
  placeholder: string;

  @Input()
  isDisabled: boolean;

  @ViewChild('editor', { static: true })
  editor: any;

  editorConfig: any;

  private touchedFn: any;
  private focusedClass = 'rich-text-editor--focused';

  constructor(
    private richTextEditorServiceService: RichTextEditorServiceService,
    private tokenRenewalService: TokenRenewalService
  ) {}

  ngOnInit() {
    this.editorConfig = this.richTextEditorServiceService.getBasicOptions();
    if (this.placeholder) {
      this.editorConfig = { ...this.editorConfig, placeholder: this.placeholder };
    }
  }

  onEditorFocusIn() {
    this.editor.editor.getContainer().classList.add(this.focusedClass);
  }

  onEditorFocusOut() {
    if (this.touchedFn) {
      this.touchedFn();
    }

    this.editor.editor.getContainer().classList.remove(this.focusedClass);
  }

  onEditorKeyUp() {
    this.tokenRenewalService.setActive();
  }

  onEditorPaste() {
    this.tokenRenewalService.setActive();
  }

  /**
   * ControlValueAccessor interface implementation
   */
  writeValue(obj: any) {
    this.editor.writeValue(obj);
  }

  /**
   * ControlValueAccessor interface implementation
   */
  registerOnChange(fn: any) {
    this.editor.registerOnChange(fn);
  }

  /**
   * ControlValueAccessor interface implementation
   */
  registerOnTouched(fn: any) {
    // Keep internal reference to the fn function so that we can call it on blur
    this.touchedFn = fn;
    this.editor.registerOnTouched(fn);
  }

  /**
   * ControlValueAccessor interface implementation
   */
  setDisabledState?(isDisabled: boolean) {
    this.editor.setDisabledState(isDisabled);
  }

  /**
   * Focusable interface implementation
   */
  setFocus(): void {
    if (this.editor.editor?.selection) {
      this.editor.editor.focus();
    }
  }
}
